import {NgModule, Sanitizer} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {TranslateService} from 'ng2-translate';
import {AlertService} from 'ng-jhipster';

import {
    CadensSharedLibsModule,
    FindLanguageFromKeyPipe,
    JhiAlertComponent,
    JhiAlertErrorComponent,
    JhiLanguageHelper,
    SafeHtmlPipe
} from './';


export function alertServiceProvider(sanitizer: Sanitizer, translateService: TranslateService) {
    // set below to true to make alerts look like toast
    let isToast = false;
    return new AlertService(sanitizer, isToast, translateService);
}

@NgModule({
    imports: [
        CadensSharedLibsModule
    ],
    declarations: [
        FindLanguageFromKeyPipe,
        SafeHtmlPipe,
        JhiAlertComponent,
        JhiAlertErrorComponent
    ],
    providers: [
        JhiLanguageHelper,
        {
            provide: AlertService,
            useFactory: alertServiceProvider,
            deps: [Sanitizer, TranslateService]
        },
        Title
    ],
    exports: [
        CadensSharedLibsModule,
        FindLanguageFromKeyPipe,
        SafeHtmlPipe,
        JhiAlertComponent,
        JhiAlertErrorComponent
    ]
})
export class CadensSharedCommonModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/shared-common.module.ts